$(document).ready(function(){
  
      $(document).find('form.search_coll').on('submit',function(e){
      e.preventDefault();
      
     // console.log($(this).find('.search-template__form-input').val());
      location.href='/search?type=product&q="'+ $(document).find('form.search_coll').find('input[type="text"]').val()+'"&ss=parts';
      $(this).find('.search-template__form-input').val()
      //	$(this).val(''+$(this).val()+'');
    });
  
  
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  
  var tech = getUrlParameter('ss');
  if(tech == 'band'){
    $('.itg_band_search').show();
     $('.itg_search.search-template__grid-wrapper').hide();
  
  }
    var tech = getUrlParameter('ss');
  if(tech == 'parts'){
    $('.itg_parts_search').show();
      $('.itg_search.search-template__grid-wrapper').hide();
  
  }

  
  
  
});

/* ============================================================
   QA fixes for the V3 theme (2026-09-24)
   1. Require a variant/part before Add to Cart on product forms.
   2. "Choose a Parts" label wording.
   3. Search page: clean browser-tab title + "no results" message.
   4. Header cart link: correct accessible name + no word wrap.
   5. Watch-repair links open in a new tab.
   6. Mobile menu (hamburger) icon no longer sits past the left edge.
   ============================================================ */
(function () {
  'use strict';

  var PRODUCT_FORM = 'form[data-product-form], form.product_form_classes';

  /* ---------- 1. Variant required before Add to Cart ---------- */

  function needsSelection(form) {
    var field = form.querySelector('[name="id"]');
    if (!field) return false;
    var value = String(field.value || '');
    return value === '' || value === 'not-selected' || value === 'undefined';
  }

  function showSelectionError(form) {
    var msg = form.querySelector('[data-itg-variant-error]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'itg-variant-error';
      msg.setAttribute('data-itg-variant-error', '');
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Please choose an option above before adding to cart.';
      var anchor = form.querySelector('[data-atc-wrapper]') || form.querySelector('[data-product-atc]');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(msg, anchor);
      } else {
        form.appendChild(msg);
      }
    }
    msg.hidden = false;
    var picker = form.querySelector('select[data-variant-option], [data-variant-option] input');
    if (picker && picker.focus) picker.focus();
  }

  function hideSelectionError(form) {
    var msg = form && form.querySelector('[data-itg-variant-error]');
    if (msg) msg.hidden = true;
  }

  function guardAddToCart(event) {
    var form = null;
    if (event.type === 'submit') {
      form = event.target;
      if (!form || !form.matches || !form.matches(PRODUCT_FORM)) return;
    } else {
      var button = event.target && event.target.closest && event.target.closest('[data-product-atc]');
      if (!button) return;
      form = button.form || button.closest('form');
      if (!form) return;
    }
    if (needsSelection(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showSelectionError(form);
    }
  }

  /* Capture phase on window so this runs before cart-drawer apps. */
  window.addEventListener('click', guardAddToCart, true);
  window.addEventListener('submit', guardAddToCart, true);

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest && event.target.closest(PRODUCT_FORM);
    if (!form) return;
    setTimeout(function () {
      if (!needsSelection(form)) hideSelectionError(form);
    }, 0);
  });

  /* ---------- 2. "Choose a Parts" -> "Choose a part" ---------- */

  function fixOptionWording(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-variant-option-choose-name]').forEach(function (label) {
      var attr = label.getAttribute('data-variant-option-choose-name');
      if (/^\s*Choose a Parts\s*$/i.test(attr)) label.setAttribute('data-variant-option-choose-name', 'Choose a part');
      if (/^\s*Choose a Parts\s*$/i.test(label.textContent)) label.textContent = 'Choose a part';
    });
    scope.querySelectorAll('select[data-variant-option] option[value="not-selected"]').forEach(function (option) {
      if (/^\s*Choose a Parts\s*$/i.test(option.textContent)) option.textContent = 'Choose a part';
    });
  }

  /* ---------- 3. Search page title + empty state ---------- */

  var CONTACT_PAGES = {
    invicta_itg: '/pages/invicta-contact-us',
    technomarine_itg: '/pages/techno-contact-us',
    coifman_itg: '/pages/s-coifman-contact-us',
    glycine_itg: '/pages/glycine-contact-us',
    chase_durer_itg: '/pages/chase-durer-contact-us',
    jw_hulme_itg: '/pages/jw-hulme-contact-us'
  };

  function customerSearchTerm(params) {
    var term = params.get('itg_q');
    if (!term) {
      term = String(params.get('q') || '');
      var split = term.lastIndexOf(') AND ');
      if (/^\s*\(/.test(term) && split !== -1) term = term.slice(split + 6);
      term = term.replace(/["“”]/g, '').trim();
      if (/[():]/.test(term)) term = '';
    }
    return String(term || '').trim();
  }

  function fixSearchPage() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.get('q')) return;
    var term = customerSearchTerm(params);

    /* Browser-tab title: show only what the customer typed. */
    var match = document.title.match(/^(.*?found for\s*)([\s\S]*?)(\s+-\s+[^-]+)$/);
    if (match) {
      document.title = match[1] + (term ? '“' + term + '”' : 'your search') + match[3];
    }

    /* No-results message. */
    if (document.querySelector('.search-template__results, [data-itg-search-empty]')) return;
    var header = document.querySelector('.search-template__header');
    if (!header) return;

    var brand = params.get('brand') || document.body.getAttribute('data-itg-brand') || 'invicta_itg';
    var contact = CONTACT_PAGES[brand] || CONTACT_PAGES.invicta_itg;

    var box = document.createElement('div');
    box.className = 'itg-search-empty';
    box.setAttribute('data-itg-search-empty', '');
    box.setAttribute('role', 'status');

    var heading = document.createElement('p');
    heading.className = 'itg-search-empty__heading';
    heading.textContent = term ? 'No results found for “' + term + '”.' : 'No results found.';

    var help = document.createElement('p');
    help.className = 'itg-search-empty__text';
    help.appendChild(document.createTextNode('Check the model number on the back of your watch and try again, or '));
    var link = document.createElement('a');
    link.href = contact;
    link.textContent = 'contact our specialists';
    help.appendChild(link);
    help.appendChild(document.createTextNode(' and we’ll help you find the right band.'));

    box.appendChild(heading);
    box.appendChild(help);
    header.parentNode.insertBefore(box, header.nextSibling);
  }

  /* ---------- 4. Header cart link ---------- */

  function fixCartLinks() {
    document.querySelectorAll('a.header-controls__cart').forEach(function (link) {
      if (/continue shopping/i.test(link.getAttribute('aria-label') || '')) {
        link.setAttribute('aria-label', 'Cart');
      }
    });
  }

  /* ---------- 5. Watch-repair links open in a new tab ---------- */
  /* Covers Watch Repair, Multi Battery Replacement and any other web
     link to an IWSC repair site, for every brand, desktop and mobile.
     mailto: links (e.g. the support email) are left alone. */

  function fixRepairLinks() {
    document.querySelectorAll('a[href^="http"][href*="iwscwatchrepair.com"], a[href^="//"][href*="iwscwatchrepair.com"]').forEach(function (link) {
      if (link.getAttribute('target') !== '_blank') link.setAttribute('target', '_blank');
      if (!/noopener/.test(link.getAttribute('rel') || '')) link.setAttribute('rel', 'noopener');
    });
  }

  /* ---------- Styles ---------- */

  function addStyles() {
    if (document.getElementById('itg-qa-fixes-css')) return;
    var style = document.createElement('style');
    style.id = 'itg-qa-fixes-css';
    style.textContent =
      '.header-controls__cart{white-space:nowrap;}' +
      /* 6. The theme gives the mobile menu button a -8px margin, pushing it past the screen edge. */
      '.mobile-header-controls{margin-left:0 !important;}' +
      '.itg-variant-error{color:#c00;font-size:14px;font-weight:600;margin:0 0 10px;}' +
      '.itg-variant-error[hidden]{display:none;}' +
      '.itg-search-empty{max-width:640px;margin:10px auto 60px;padding:0 20px;text-align:center;}' +
      '.itg-search-empty__heading{font-size:20px;font-weight:600;margin:0 0 10px;}' +
      '.itg-search-empty__text{margin:0;}' +
      '.itg-search-empty__text a{text-decoration:underline;}';
    document.head.appendChild(style);
  }

  function init() {
    addStyles();
    fixOptionWording();
    fixSearchPage();
    fixCartLinks();
    fixRepairLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Quick-shop modals and the "Bands That Fit" list load later. */
  document.addEventListener('shopify:section:load', init);
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        fixOptionWording();
        fixCartLinks();
        fixRepairLinks();
      }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   T-Bars / Spring Bar Set: watch model number is required
   everywhere it can be added (2026-09-24).

   The product page already requires the field. Items can also be
   added from the cart drawer upsell (UpCart) and product grids,
   which post straight to /cart/add without the property. This
   intercepts those requests, asks for the model number in a
   small dialog, and adds it as the "Watch Model Number" line-item
   property. If the customer cancels, nothing is added.
   ============================================================ */
(function () {
  'use strict';

  var TBAR_HANDLE = 't-bars-or-spring-bar-set';
  var TBAR_FALLBACK_IDS = ['44583244890366'];
  var PROP = 'Watch Model Number';
  var FLAT_PROP = 'properties[' + PROP + ']';
  var CACHE_KEY = 'itg_tbar_variant_ids';

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var tbarIds = TBAR_FALLBACK_IDS.slice();
  var idsPromise = null;

  try {
    var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    if (cached && cached.length) tbarIds = cached;
  } catch (e) {}

  function loadTbarIds() {
    if (idsPromise) return idsPromise;
    if (!nativeFetch) return Promise.resolve(tbarIds);
    idsPromise = nativeFetch('/products/' + TBAR_HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.variants && p.variants.length) {
          tbarIds = p.variants.map(function (v) { return String(v.id); });
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(tbarIds)); } catch (e) {}
        }
        return tbarIds;
      })
      .catch(function () { return tbarIds; });
    return idsPromise;
  }

  function isTbar(id) {
    return id != null && tbarIds.indexOf(String(id)) !== -1;
  }

  function hasModel(item) {
    var nested = item && item.properties && item.properties[PROP];
    var flat = item && item[FLAT_PROP];
    return !!(String(nested || '').trim() || String(flat || '').trim());
  }

  function isCartAdd(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try {
      var u = new URL(String(url), window.location.href);
      return u.origin === window.location.origin && /\/cart\/add(\.js)?\/?$/.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  /* Returns { needs: bool, apply: fn(model) -> new body } */
  function inspectBody(body) {
    if (body == null) return { needs: false };

    /* JSON (UpCart upsell / AJAX cart) */
    if (typeof body === 'string' && /^\s*[\[{]/.test(body)) {
      var data;
      try { data = JSON.parse(body); } catch (e) { return { needs: false }; }
      var items = Array.isArray(data.items) ? data.items : [data];
      var targets = items.filter(function (it) { return it && isTbar(it.id) && !hasModel(it); });
      if (!targets.length) return { needs: false };
      return {
        needs: true,
        apply: function (model) {
          targets.forEach(function (it) {
            it.properties = Object.assign({}, it.properties || {});
            it.properties[PROP] = model;
          });
          return JSON.stringify(data);
        }
      };
    }

    /* FormData */
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (!isTbar(body.get('id')) || String(body.get(FLAT_PROP) || '').trim()) return { needs: false };
      return { needs: true, apply: function (model) { body.set(FLAT_PROP, model); return body; } };
    }

    /* URL-encoded */
    var params = null;
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) params = body;
    else if (typeof body === 'string') params = new URLSearchParams(body);
    if (params) {
      if (!isTbar(params.get('id')) || String(params.get(FLAT_PROP) || '').trim()) return { needs: false };
      var wasString = typeof body === 'string';
      return {
        needs: true,
        apply: function (model) {
          params.set(FLAT_PROP, model);
          return wasString ? params.toString() : params;
        }
      };
    }

    return { needs: false };
  }

  /* ---------- Dialog ---------- */

  var openDialog = null;

  function askForModel() {
    if (openDialog) return openDialog;

    openDialog = new Promise(function (resolve) {
      var previousFocus = document.activeElement;

      var overlay = document.createElement('div');
      overlay.className = 'itg-model-dialog';

      var box = document.createElement('div');
      box.className = 'itg-model-dialog__box';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-labelledby', 'itg-model-dialog-title');

      var form = document.createElement('form');
      form.noValidate = true;

      var title = document.createElement('h2');
      title.id = 'itg-model-dialog-title';
      title.className = 'itg-model-dialog__title';
      title.textContent = 'Watch model number required';

      var text = document.createElement('p');
      text.className = 'itg-model-dialog__text';
      text.textContent = 'T-bars and spring bars are sized to your watch. Enter your watch model number so we send the right set.';

      var label = document.createElement('label');
      label.className = 'itg-model-dialog__label';
      label.setAttribute('for', 'itg-model-dialog-input');
      label.textContent = 'Watch Model Number *';

      var input = document.createElement('input');
      input.id = 'itg-model-dialog-input';
      input.className = 'itg-model-dialog__input';
      input.type = 'text';
      input.autocomplete = 'off';
      input.placeholder = 'Enter your watch model number';
      input.setAttribute('aria-required', 'true');

      var error = document.createElement('p');
      error.className = 'itg-model-dialog__error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      error.textContent = 'Please enter your watch model number.';

      var how = document.createElement('p');
      how.className = 'itg-model-dialog__help';
      var howLink = document.createElement('a');
      howLink.href = '/blogs/news/how-to-find-your-model-number';
      howLink.target = '_blank';
      howLink.rel = 'noopener';
      howLink.textContent = 'How to find your model number';
      how.appendChild(howLink);

      var actions = document.createElement('div');
      actions.className = 'itg-model-dialog__actions';

      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'itg-model-dialog__cancel';
      cancel.textContent = 'Cancel';

      var submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'itg-model-dialog__submit';
      submit.textContent = 'Add to cart';

      actions.appendChild(cancel);
      actions.appendChild(submit);
      form.appendChild(title);
      form.appendChild(text);
      form.appendChild(label);
      form.appendChild(input);
      form.appendChild(error);
      form.appendChild(how);
      form.appendChild(actions);
      box.appendChild(form);
      overlay.appendChild(box);
      document.body.appendChild(overlay);

      function close(value) {
        document.removeEventListener('keydown', onKey, true);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        openDialog = null;
        if (previousFocus && previousFocus.focus) {
          try { previousFocus.focus(); } catch (e) {}
        }
        resolve(value);
      }

      function onKey(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          close(null);
        }
        if (event.key === 'Tab') {
          var focusables = [input, howLink, cancel, submit];
          var index = focusables.indexOf(document.activeElement);
          if (event.shiftKey && index <= 0) {
            event.preventDefault();
            submit.focus();
          } else if (!event.shiftKey && index === focusables.length - 1) {
            event.preventDefault();
            input.focus();
          }
        }
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var value = input.value.trim();
        if (!value) {
          error.hidden = false;
          input.classList.add('itg-model-dialog__input--error');
          input.focus();
          return;
        }
        close(value);
      });
      input.addEventListener('input', function () {
        if (input.value.trim()) {
          error.hidden = true;
          input.classList.remove('itg-model-dialog__input--error');
        }
      });
      cancel.addEventListener('click', function () { close(null); });
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close(null);
      });
      document.addEventListener('keydown', onKey, true);

      setTimeout(function () { input.focus(); }, 30);
    });

    return openDialog;
  }

  function cancelledResponse() {
    var body = JSON.stringify({
      status: 422,
      message: 'Cart Error',
      description: 'Please enter your watch model number to add the T-Bars or Spring Bar Set.'
    });
    return new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  /* ---------- fetch() ---------- */

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
      var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      var body = init && init.body;

      if (!isCartAdd(url, method) || body == null) {
        return nativeFetch(input, init);
      }

      return loadTbarIds().then(function () {
        var check = inspectBody(body);
        if (!check.needs) return nativeFetch(input, init);
        return askForModel().then(function (model) {
          if (!model) return cancelledResponse();
          var nextInit = Object.assign({}, init, { body: check.apply(model) });
          return nativeFetch(input, nextInit);
        });
      });
    };
  }

  /* ---------- XMLHttpRequest ---------- */

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__itgMethod = method;
    this.__itgUrl = url;
    return xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (!isCartAdd(xhr.__itgUrl, xhr.__itgMethod) || body == null) {
      return xhrSend.apply(xhr, arguments);
    }
    loadTbarIds().then(function () {
      var check = inspectBody(body);
      if (!check.needs) return xhrSend.call(xhr, body);
      return askForModel().then(function (model) {
        if (!model) {
          try { xhr.abort(); } catch (e) {}
          return;
        }
        xhrSend.call(xhr, check.apply(model));
      });
    });
  };

  /* ---------- Plain form posts (grids without the cart app) ---------- */

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.matches && form.matches('form[data-product-form], form.product_form_classes')) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField || !isTbar(idField.value)) return;
    var existing = form.querySelector('[name="' + FLAT_PROP + '"]');
    if (existing && String(existing.value || '').trim()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    askForModel().then(function (model) {
      if (!model) return;
      if (!existing) {
        existing = document.createElement('input');
        existing.type = 'hidden';
        existing.name = FLAT_PROP;
        form.appendChild(existing);
      }
      existing.value = model;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }, true);

  /* ---------- Styles ---------- */

  function addStyles() {
    if (document.getElementById('itg-model-dialog-css')) return;
    var style = document.createElement('style');
    style.id = 'itg-model-dialog-css';
    style.textContent =
      '.itg-model-dialog{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;}' +
      '.itg-model-dialog__box{background:#fff;color:#111;width:100%;max-width:420px;padding:24px;border-radius:4px;box-shadow:0 10px 40px rgba(0,0,0,.3);font-size:15px;line-height:1.45;text-align:left;}' +
      '.itg-model-dialog__title{font-size:20px;font-weight:700;margin:0 0 8px;}' +
      '.itg-model-dialog__text{margin:0 0 16px;}' +
      '.itg-model-dialog__label{display:block;font-weight:600;margin:0 0 6px;}' +
      '.itg-model-dialog__input{display:block;width:100%;box-sizing:border-box;padding:11px 12px;border:1px solid #b8b8b8;border-radius:2px;font-size:16px;background:#fff;color:#111;}' +
      '.itg-model-dialog__input:focus{outline:none;border-color:#000;}' +
      '.itg-model-dialog__input--error{border-color:#c00;}' +
      '.itg-model-dialog__error{color:#c00;font-size:14px;margin:6px 0 0;}' +
      '.itg-model-dialog__error[hidden]{display:none;}' +
      '.itg-model-dialog__help{margin:8px 0 0;font-size:14px;}' +
      '.itg-model-dialog__help a{text-decoration:underline;color:inherit;}' +
      '.itg-model-dialog__actions{display:flex;gap:10px;justify-content:flex-end;margin-top:20px;}' +
      '.itg-model-dialog__actions button{padding:11px 18px;font-size:15px;font-weight:600;border-radius:2px;cursor:pointer;}' +
      '.itg-model-dialog__cancel{background:#fff;color:#111;border:1px solid #111;}' +
      '.itg-model-dialog__submit{background:#000;color:#fff;border:1px solid #000;}';
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStyles);
  } else {
    addStyles();
  }
  loadTbarIds();
})();
